module.exports = __webpack_public_path__ + "img/SeedLogo.03a37c63.png";